const mailsettings = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Mail Settings",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "Mail Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "onlineServicesTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    sender_email: {
                      type: "text",
                      label: "Sender Address",
                      placeholder: "Enter Email",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    default_email: {
                      type: "text",
                      label: "Default Recipient Address",
                      placeholder: "Enter Email",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    get_help_with: {
                      type: "heading",
                      label: "Get Help With",
                      size: "12",
                    },
                    join_the_practice_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Join the Practice Form",
                      placeholder: "Join the Practice Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    prescriptions_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Prescriptions Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    cancel_appointment_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Cancel Appointment Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    join_the_practice_form_email: {
                      type: "text",
                      label: "join_the_practice_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "join_the_practice_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    prescriptions_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "prescriptions_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    cancel_appointment_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "cancel_appointment_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    sick_fit_notes_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Sick/Fit Notes Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    test_results_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Test Results Form",
                      placeholder: "Test Results Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    ppg_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "PPG Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    sick_fit_notes_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "sick_fit_notes_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    test_results_form_email: {
                      type: "text",
                      label: "test_results_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "test_results_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    ppg_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "ppg_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    admin_query_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Administrative Query Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    private_letter_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Private Letter Request Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    practice_health_champion_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Practice Health Champion Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    admin_query_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "admin_query_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    private_letter_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "private_letter_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    practice_health_champion_form_email: {
                      type: "text",
                      label: "practice_health_champion_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "practice_health_champion_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nursing_home_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Nursing Home Registration Form",
                      placeholder: "Nursing Home Registration Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    online_service_registration_check: {
                      type: "mailSettingsCheckbox",
                      label: "Online Service Registration",
                      placeholder: "Online Service Registration",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    temporary_registration_check: {
                      type: "mailSettingsCheckbox",
                      label: "Temporary Registration Form",
                      placeholder: "Temporary Registration Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nursing_home_form_email: {
                      type: "text",
                      label: "nursing_home_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "nursing_home_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    online_service_registration_email: {
                      type: "text",
                      label: "online_service_registration_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "online_service_registration_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    temporary_registration_check_email: {
                      type: "text",
                      label: "temporary_registration_check_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "temporary_registration_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    ppg_suggestion_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "PPG Suggestion Form",
                      placeholder: "PPG Suggestion Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    automated_prescription_collection_registration_check: {
                      type: "mailSettingsCheckbox",
                      label: "Automated Prescription Collection Registration",
                      placeholder:
                        "Automated Prescription Collection Registration",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    proxy_access_check: {
                      type: "mailSettingsCheckbox",
                      label: "Proxy Access Form",
                      placeholder: "Proxy Access Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    ppg_suggestion_form_email: {
                      type: "text",
                      label: "ppg_suggestion_form_check",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "ppg_suggestion_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },

                    automated_prescription_collection_registration_form_email: {
                      type: "text",
                      label: "prescriptions_form_email ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn:
                        "automated_prescription_collection_registration_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },

                    proxy_access_form_email: {
                      type: "text",
                      label: "proxy_access_check ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "proxy_access_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    reasonable_adjustment_questionnaire_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Reasonable Adjustment Questionnaire Form",
                      placeholder: "Reasonable Adjustment Questionnaire Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    reasonable_adjustment_questionnaire_form_email: {
                      type: "text",
                      label: "reasonable_adjustment_questionnaire_form_check ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn:
                        "reasonable_adjustment_questionnaire_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },

                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    keep_us_updated: {
                      type: "heading",
                      label: "Keep Us Updated",
                      size: "12",
                    },
                    change_of_personal_details_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Change of Personal Details Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    carer_info_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Carer Information Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    national_data_optout_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "National Data Opt-Out Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    change_of_personal_details_form_email: {
                      type: "text",
                      label: "prescriptions_form_email ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "change_of_personal_details_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    carer_info_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "carer_info_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    national_data_optout_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "national_data_optout_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    summary_care_record_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Summary Care Record (opt-out) Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    communication_consent_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Communication Consent Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nominate_your_pharmacy_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Nominate your Pharmacy Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    summary_care_record_form_email: {
                      type: "text",
                      label: "prescriptions_form_email  ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "summary_care_record_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    communication_consent_form_email: {
                      type: "text",
                      label: "prescriptions_form_email   ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "communication_consent_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nominate_your_pharmacy_form_email: {
                      type: "text",
                      label: "prescriptions_form_email    ",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "nominate_your_pharmacy_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    access_to_medical_records_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Access to Medical Records Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    update_clinical_record_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Update Clinical Record Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                      vaccine_refusal_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Vaccine Refusal Form",
                      placeholder: "Vaccine Refusal Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    access_to_medical_records_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "access_to_medical_records_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    update_clinical_record_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "update_clinical_record_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    vaccine_refusal_form_email: {
                      type: "text",
                      label: "vaccine_refusal_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "vaccine_refusal_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    health_reviews: {
                      type: "heading",
                      label: "Health Reviews",
                      size: "12",
                    },
                    travel_questionare_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Travel Questionnaire Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    asthma_questionare_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Asthma Questionnaire Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    smoking_and_alcohol_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Smoking & Alcohol Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    travel_questionare_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "travel_questionare_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    asthma_questionare_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "asthma_questionare_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    smoking_and_alcohol_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "smoking_and_alcohol_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    children_and_teenagers_with_asthma_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Children and Teenagers with Asthma Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    decline_flu_jab_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Decline Flu Jab Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    decline_medical_review_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Decline Medical Review Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    children_and_teenagers_with_asthma_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn:
                        "children_and_teenagers_with_asthma_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    decline_flu_jab_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "decline_flu_jab_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    decline_medical_review_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "decline_medical_review_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    height_and_weight_update_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Height & Weight Update Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nhs_health_checks_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "NHS Health Checks Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    medication_review_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Medication Review Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    height_and_weight_update_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "height_and_weight_update_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nhs_health_checks_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "nhs_health_checks_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    medication_review_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "medication_review_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    home_bp_reading_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Home BP Reading Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    contraceptive_bp_monitoring_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Contraceptive BP Monitoring Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    care_home_gp_contact_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Care Home GP Contact Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    home_bp_reading_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "home_bp_reading_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    contraceptive_bp_monitoring_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "contraceptive_bp_monitoring_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    care_home_gp_contact_form_email: {
                      type: "text",
                      label: "Care Home GP Contact Form",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "care_home_gp_contact_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    coil_removal_form__check: {
                      type: "mailSettingsCheckbox",
                      label: "Coil Removal Form",
                      placeholder: "Coil Removal Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    coil_insertion_replacement_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Coil Insertion/Replacement Form",
                      placeholder: "Coil Insertion/Replacement Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },

                    implant_insertion_replacement_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Implant Insertion/Replacement Form",
                      placeholder: "Implant Insertion/Replacement Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    coil_removal_form_email: {
                      type: "text",
                      label: "Coil Removal Form",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "coil_removal_form__check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    coil_insertion_replacement_form_check_email: {
                      type: "text",
                      label: "Coil Insertion/Replacement Form",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "coil_insertion_replacement_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    implant_insertion_replacement_form__check_email: {
                      type: "text",
                      label: "Implant Insertion/Replacement Form",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "implant_insertion_replacement_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    referrals: {
                      type: "heading",
                      label: "Referrals",
                      size: "12",
                    },
                    midwife_self_referral_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Midwife self-referral Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nhsd_weight_management_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "NHSD Weight Management Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    mental_health_occupational_therapy_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Mental Health Occupational Therapy Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    midwife_self_referral_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "midwife_self_referral_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    nhsd_weight_management_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "nhsd_weight_management_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    mental_health_occupational_therapy_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn:
                        "mental_health_occupational_therapy_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    social_prescribing_support_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Social Prescribing Support Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    vasectomy_self_referral_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Vasectomy self-referral form",
                      placeholder: "Vasectomy self-referral Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "8",
                      style: "",
                    },

                    social_prescribing_support_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "social_prescribing_support_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    vasectomy_self_referral_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "vasectomy_self_referral_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    patient_feedback: {
                      type: "heading",
                      label: "Patient Feedback",
                      size: "12",
                    },
                    feedback_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Feedback Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    feedback_form_disable_email: {
                      type: "mailSettingsCheckbox",
                      label: "Disable email",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "2",
                      style: "",
                    },
                    complaints_form_check: {
                      type: "mailSettingsCheckbox",
                      label: "Complaints Form",
                      placeholder: "Prescriptions Form",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "8",
                      style: "",
                    },
                    feedback_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "feedback_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                    complaints_form_email: {
                      type: "text",
                      label: "prescriptions_form_email",
                      hideLabel: true,
                      placeholder: "Enter Email",
                      disableOn: "complaints_form_check",
                      disableOnValue: "false",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "4",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { mailsettings };
